"use client";
import { Collapse } from "antd";
const { Panel } = Collapse;
import styles from "@/src/component/blog/blog-detail.module.scss";

export default function BlogToc({ data }) {
  return (
    <div className={styles.tableOfContents}>
      <Collapse accordion>
        <Panel header="MỤC LỤC" className={styles.tableOfContentsTitle}>
        <div
          className={styles.tableOfContentsList}
          dangerouslySetInnerHTML={{
            __html: data?.tableOfContents,
          }}
          ></div>
        </Panel>
      </Collapse>
    </div>
  );
}
